/**
 * Form
 * @version 3.0.0
 */

function openAllForms() {
  const inputs = document.querySelectorAll(".js-form-overlay .rt-form__input");
  inputs.forEach((input) => {
    const form = input.closest(".js-form-overlay");

    // Select2 renders a visible selection/placeholder even when the hidden
    // select has no value. Keep its label floated to prevent overlap.
    if (form.classList.contains("rt-form--select2") || input.value.length > 0) {
      form.classList.add("is-active");
    } else {
      form.classList.remove("is-active");
    }
  });
}

function openFormOnFocus() {
  const inputs = document.querySelectorAll(".js-form-overlay .rt-form__input");
  inputs.forEach((input) => {
    input.addEventListener("focus", (event) => {
      const item = event.currentTarget;
      openAllForms();
      item.closest(".js-form-overlay").classList.add("is-active");
    });

    input.addEventListener("change", openAllForms);
  });
}

document.addEventListener("DOMContentLoaded", openAllForms);
document.addEventListener("DOMContentLoaded", openFormOnFocus);
